import { authFetch } from '@/services/apiClient'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
  message?: string
}

export interface LessonProgress {
  progress_id: number
  lesson_id: number
  is_completed: boolean
  watch_duration_seconds: number
  completed_at: string | null
}

async function parseJson<T>(res: Response): Promise<ApiResponse<T>> {
  try {
    return await res.json()
  } catch {
    return { success: false, error: 'เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ' }
  }
}

export const updateLessonProgress = async (
  enrollmentId: number,
  lessonId: number,
  isCompleted: boolean,
  watchDurationSeconds: number,
): Promise<LessonProgress> => {
  const res = await authFetch(`/enrollments/${enrollmentId}/lessons/${lessonId}/progress`, {
    method: 'PUT',
    body: JSON.stringify({ is_completed: isCompleted, watch_duration_seconds: watchDurationSeconds }),
  })
  const json = await parseJson<LessonProgress>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'บันทึก progress ไม่สำเร็จ')
  return json.data
}

export const getEnrollmentProgress = async (enrollmentId: number): Promise<LessonProgress[]> => {
  const res = await authFetch(`/enrollments/${enrollmentId}/progress`)
  const json = await parseJson<LessonProgress[]>(res)
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'โหลด progress ไม่สำเร็จ')
  return json.data
}
